import { ControllerRenderProps, FieldError, FieldValues } from "react-hook-form";
import { FormControl, FormHelperText, TextField, styled } from "@mui/material";

import { TextFieldSchema } from "@/types/form-generator-schema-type";
import RtlProvider from "@/Providers/RtlProvider";
interface IProps {
    field: ControllerRenderProps<FieldValues, string>;
    label?: string;
    placeholder: string;
    className?: string;
    errorMessage: FieldError;
    props?: TextFieldSchema["props"];
}

const StyledTextField = styled(TextField)(() => ({
    "& .MuiFormLabel-asterisk": {
        color: "red",
        fontSize: "20px",
    },
}));

const FormText = ({ field, label, placeholder, className, errorMessage, props = {} }: IProps) => {
    return (
        <FormControl fullWidth className={className} margin="normal" variant="outlined">
            <RtlProvider>
                <StyledTextField
                    {...field}
                    {...props}
                    fullWidth
                    inputProps={{ style: { direction: "rtl" } }}
                    label={label}
                    placeholder={placeholder}
                    variant="outlined"
                />
            </RtlProvider>
            {errorMessage?.message ? <FormHelperText error>{errorMessage?.message}</FormHelperText> : null}
        </FormControl>
    );
};

export default FormText;
